<template>
  <button
    class="ui-gift-btn"
    type="button"
    @click.prevent="onClick"
  >
    <div class="ui-gift-btn_inner">
      <div class="ui-gift-btn_icon">
        <img src="@/assets/img/misc/gift-icon.svg" alt="">
      </div>
      <div class="ui-gift-btn_text">{{text}}</div>
    </div>

  </button>
</template>

<script>
export default {
  name: `ui-gift-btn`,

  props: {
    text: {
      type: String,
      default: ``,
    },
  },

  methods: {
    onClick() {
      this.$emit(`click`)
    }
  }
}
</script>

<style lang="sass">
.ui-gift-btn
  background: linear-gradient(225deg, #FB865D, #FF396D)
  border-radius: px-em(50)
  position: relative
  padding: px-em(8) px-em(32)
  color: #FD6364
  min-height: px-em(54)

  &::before
    content: ""
    display: block
    position: absolute
    inset: px-em(2)
    background: #fff
    border-radius: px-em(50)

.ui-gift-btn_inner
  display: flex
  align-items: center
  position: relative
  z-index: 1

.ui-gift-btn_icon
  max-width: px-em(29)
  margin-right: px-em(10)
  transform: translateY(px-em(2))

.ui-gift-btn_text
  font-weight: 500
</style>
